import {Component, OnInit} from "@angular/core";
import {Auth2Service} from "../../../services/auth2.service";
import {ApiService} from "../../../services/api.service";
import {UserService} from "../services/users.service";
import {Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";
import {LoggedInPageBaseComponent} from "../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-subscription-management',
  templateUrl: './subscription-management.component.html',
  styleUrls: ['./subscription-management.component.scss'],
  standalone: false
})
export class SubscriptionManagementComponent extends LoggedInPageBaseComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Subscription'}
  ];
  username: string = '';
  impersonatedEmail: any = null;
  invoiceDtos: any = [];

  messages: any[] = [];
  successMessages: any[] = [];
  showMessages: boolean = false;

  showModalErrorMessages: boolean = false;
  showModalSuccessMessages: boolean = false;
  modalErrorMessages: any[] = [];
  modalSuccessMessages: any[] = [];

  mostRecentSubscription: any = null;

  subscriptionExpirationDate: string = '';

  subscriptionActive: boolean = false;
  cancelAtPeriodEnd: boolean = false;

  defaultPaymentCard: any = {};

  savedUserId = '';
  savedUsername: string = '';
  savedPassword: string = '';
  savedFirstName: string = '';
  savedLastName: string = '';
  savedPhoneNumber: string = '';
  savedEmail:string = '';
  savedEIN: string = '';
  savedCompanyName: string = '';
  //Physical Address for Square Integration
  savedAddressLine1: string = '';
  savedAddressLine2: string = '';
  savedAddressLine3: string = '';
  savedCity: string = '';
  savedState: string = '';
  savedCountry: string = '';
  savedZipCode: string = '';
  savedCause: string = '';
  savedAutoRenewalString: string = 'N';
  savedIsConsultantFlag: string = 'N';

  isConsultant: string = 'N';
  hasClients: string = 'N';

  savedConsultantId: number = -1;
  savedConsultantEmail: string = "";
  savedConsultantReferralCode: string = "";
  savedConsultantReferralCodeVerified: string = "";
  savedConsultantRoleName: string = "";
  savedConsultantDisplayRoleName: string = "";

  consultantAutocomplete: any[] = [];
  inviteButtonClicked: boolean = false;

  consultantReadOnlyButton: boolean = true;
  consultantManagerButton: boolean = false;

  showReferralCodeErrorMessages: boolean = false;
  referralCodeErrorMessages: any[] = [];
  showReferralCodeSuccessMessages: boolean = false;
  referralCodeSuccessMessages: any[] = [];

  consultantEmailInvitationReminderModal: any = null;
  inviteConsultantEmailModalBtn1: any = null;
  closeModalBtn2: any = null;
  consultantEmailInvitationCloseSpan: any = null;

  constructor(private auth2ServiceChild: Auth2Service, public apiService: ApiService, private userService : UserService,
              private routerChild: Router, private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy Manage Subscription");
  }

  setUpClientInviteReminderModal(): void {
    // Get the modal
    this.consultantEmailInvitationReminderModal = document.getElementById("consultant-email-invitation-reminder-modal-id");

    // Get the button that opens the modal
    // @ts-ignore
    this.inviteConsultantEmailModalBtn1 = document.getElementById("invite-consultant-email-modal-button1-id");
    this.closeModalBtn2 = document.getElementById("close-modal-button1-id");
    // Get the <span> element that closes the modal
    this.consultantEmailInvitationCloseSpan = document.getElementsByClassName("close")[0] as HTMLElement;
  }

  ngOnInit() {
    // @ts-ignore
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    if (this.impersonatedEmail != null && this.username != this.impersonatedEmail) {
      //impersonate emails are not allowed on this page
      this.pageErrorMessages.push({
        field: 'Impersonated Emails not allowed on page.',
        detail: 'Consultants are not allowed to manage their client subscriptions.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.routerChild.navigateByUrl('app/users/dashboard');
    }
    this.setUpClientInviteReminderModal();
    if (this.username) {
      const filter: any = {
        username: this.username,
        startDate: '',
        endDate: ''
      };
      // @ts-ignore
      this.userService.getUserProfile(this.username)
        .subscribe((result: any) => {
          if (result && result.body) {
            this.populateData(result.body)
            /*
            this.userService.getApprovedConsultantsDropdown(this.username, this.impersonatedEmail).subscribe(
              (approvedConsultantsResponse: any) => {
                if (approvedConsultantsResponse && approvedConsultantsResponse.body) {
                  this.consultantAutocomplete = approvedConsultantsResponse.body
                }
              }, (approvedConsultantsError: HttpErrorResponse) => {
                this.messages.push({
                  field: 'Get Approved Consultants Error',
                  detail: 'Failed to pull the list of approved consultants. Please refresh the page.',
                  severity: 'error'
                });
                this.showMessagesToUser();
              })*/
          }
        }, (error: HttpErrorResponse) => {
          if (error.status == 401) {
            this.messages.push({
              field: 'Get Profile Error',
              detail: 'You have logged out due to session being invalid. ' + error.error.message,
              severity: 'error'
            });
            this.showMessagesToUser();
            this.routerChild.navigateByUrl('app/login');
          }
        });
      //grab the current subscription by looking at the most recent payment
      this.userService.getMostRecentSubscription(this.username).subscribe((result: any) => {
        if (result && result.body) {
          this.mostRecentSubscription = result.body;
          this.calculateExpirationDate2();
        }
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Subscription Management API Error',
          detail: 'Failed to to get most recent paid invoice...',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        this.pageErrorMessages = [];
      })
      let invoiceHistoryObj: any = null;
      let invoiceHistory: string | null = sessionStorage.getItem('invoiceHistory');
      if (invoiceHistory) {
        invoiceHistoryObj = JSON.parse(invoiceHistory);
        this.invoiceDtos = invoiceHistoryObj.invoiceHistory
      } else {
          //grab all the payment history
          this.userService.getInvoiceHistory(filter, this.username).subscribe((result: any) => {
            if (result && result.body) {
              this.invoiceDtos = result.body.invoiceHistory;
            }
          }, (err: HttpErrorResponse) => {
            this.redirectToLogin(err);
            this.pageErrorMessages.push({
              field: 'Subscription Management API Error',
              detail: 'Failed to to get invoice history...',
              severity: 'error'
            });
            this.showPageErrorMessagesToUser();
            this.pageErrorMessages = [];
          });
        }
      }
  }

  private populateData(dto: any) {
    let userDto: any = null;
    if (dto.userDto) {
      userDto = dto.userDto
    } else {
      userDto = dto;
    }

    if (userDto.isConsultant) {
      this.savedIsConsultantFlag = userDto.isConsultant;
    }

    if (userDto.userId) {
      this.savedUserId = userDto.userId;
    }

    if (userDto.firstName) {
      this.savedFirstName = userDto.firstName;
    }

    if (userDto.lastName) {
      this.savedLastName = userDto.lastName;
    }

    if (userDto.email) {
      this.savedEmail = userDto.email;
    }

    if (userDto.phoneNumber) {
      this.savedPhoneNumber = userDto.phoneNumber;
    }

    if (userDto.nonprofitDonorEin) {
      this.savedEIN = userDto.nonprofitDonorEin;
    }

    if (userDto.companyName) {
      this.savedCompanyName = userDto.companyName;
    }

    if (userDto.username) {
      this.savedUsername = userDto.username;
    }

    if (userDto.addressLine1) {
      this.savedAddressLine1 = userDto.addressLine1;
    }

    if (userDto.addressLine2) {
      this.savedAddressLine2 = userDto.addressLine2;
    }

    if (userDto.addressLine3) {
      this.savedAddressLine3 = userDto.addressLine3;
    }

    if (userDto.city) {
      this.savedCity = userDto.city;
    }

    if (userDto.state) {
      this.savedState = userDto.state;
    }

    if (userDto.country) {
      this.savedCountry = userDto.country;
    }

    if (userDto.zipCode) {
      this.savedZipCode = userDto.zipCode;
    }

    if (userDto.cause) {
      this.savedCause = userDto.cause;
    }

    if (userDto.consultantId) {
      this.savedConsultantId = userDto.consultantId;
    }

    if (userDto.consultantEmail) {
      this.savedConsultantEmail = userDto.consultantEmail;
    }

    if (userDto.consultantReferralCodeVerified) {
      this.savedConsultantReferralCodeVerified = userDto.consultantReferralCodeVerified;
    }

    if (userDto.consultantRoleName) {
      this.savedConsultantRoleName = userDto.consultantRoleName;
      this.consultantReadOnlyButton = true;
      this.consultantManagerButton = false;
      if (this.savedConsultantRoleName == 'READ_ONLY_ACCESS') {
        this.consultantReadOnlyButton = true;
        this.consultantManagerButton = false;
      } else if (this.savedConsultantRoleName == 'COLLABORATIVE_ACCESS') {
        this.consultantReadOnlyButton = false;
        this.consultantManagerButton = true;
      }
    }

    if (userDto.consultantDisplayRoleName) {
      this.savedConsultantDisplayRoleName = userDto.consultantDisplayRoleName;
    }
  }

  trackAccessLogicalExpression(permission: string): void {
    if (permission == 'READ_ONLY_ACCESS') {
      this.consultantReadOnlyButton = true;
      this.consultantManagerButton = false;
    } else if (permission == 'COLLABORATIVE_ACCESS') {
      this.consultantReadOnlyButton = false;
      this.consultantManagerButton = true;
    } else {
      //Should never happen but ensure at least role is accepted
      this.consultantReadOnlyButton = true;
      this.consultantManagerButton = false;
    }
  }

  showMessagesToUser(delayTime: number = 8000): void {
    this.showMessages = true;
    const counterFn = () => {
      this.showMessages = false;
    }
    setTimeout(counterFn, delayTime);
  }

  removeConsultantFromUser(): void {
    this.messages = [];
    this.successMessages = [];
    this.userService.removeConsultantFromUser(this.username).subscribe(
      (result: any) => {
        if (result && result.body) {
          this.savedConsultantId = -1;
          this.savedConsultantEmail = "";
          this.savedConsultantReferralCode = "";
          this.savedConsultantReferralCodeVerified = "";
          this.savedConsultantRoleName = "";
          this.savedConsultantDisplayRoleName = "";
          this.successMessages.push({
            field: 'Update Consultant Role Success',
            detail: 'Update Consultant Role Success!',
            severity: 'success'
          });
          this.showSuccessMessagesToUser();
        }
      }, (error: HttpErrorResponse) => {
        this.messages.push({
          field: 'Failed to fetch the causes and giving interests',
          detail: 'Failed to fetch the causes and giving interests. Please refresh the page.',
          severity: 'error'
        });
        this.showMessagesToUser();
      }
    );
  }

  updateConsultantRole(): void {
    let consultantRoleName: string = 'READ_ONLY_ACCESS';
    if (this.consultantReadOnlyButton) {
      consultantRoleName = 'READ_ONLY_ACCESS';
    } else if (this.consultantManagerButton) {
      consultantRoleName = 'COLLABORATIVE_ACCESS';
    }
    this.userService.updateConsultantRole(this.savedConsultantEmail, consultantRoleName, this.username).subscribe(
      (result: any) => {
        if (result && result.body) {
          this.successMessages.push({
            field: 'Update Consultant Role Success',
            detail: 'Consultant Role Updated Successfully',
            severity: 'success'
          });
          this.showSuccessMessagesToUser();
        }
      }, (error: HttpErrorResponse) => {
        this.messages.push({
          field: 'Update Consultant Role Failure',
          detail: 'Update Consultant Role Failure.',
          severity: 'error'
        });
        this.showMessagesToUser();
      }
    );
  }

  showModalSuccessMessagesToUser(delayTime: number = 8000): void {
    this.showModalSuccessMessages = true;
    const counterFn = () => {
      this.showModalSuccessMessages = false;
    }
    setTimeout(counterFn, delayTime);
  }

  showModalErrorMessagesToUser(delayTime: number = 8000): void {
    this.showModalErrorMessages = true;
    const counterFn = () => {
      this.showModalErrorMessages = false;
    }
    setTimeout(counterFn, delayTime);
  }

  inviteConsultantToCollaborate(): void {
    this.modalSuccessMessages = [];
    this.showModalSuccessMessages = false;
    this.modalErrorMessages = [];
    this.showModalErrorMessages = false;

    this.inviteButtonClicked = true;
    const consultantEmailEl = document.getElementById('consultant-email-text-id');
    // @ts-ignore
    let consultantEmailTemp: string = consultantEmailEl.value;
    let consultantRoleName: string = 'READ_ONLY_ACCESS';
    if (this.consultantReadOnlyButton) {
      consultantRoleName = 'READ_ONLY_ACCESS';
    } else if (this.consultantManagerButton) {
      consultantRoleName = 'COLLABORATIVE_ACCESS';
    }
    this.messages = [];
    this.successMessages = [];
    if (!consultantEmailTemp) {
      this.messages.push({
        field: 'Email',
        detail: 'Email: ' + consultantEmailTemp + ' is not valid.',
        severity: 'error'
      });
    }

    if (this.messages.length > 0) {
      this.showMessagesToUser();
      return;
    }

    this.userService.inviteConsultantToCollaborate(consultantEmailTemp, consultantRoleName, this.username)
      .subscribe((result: any) => {
        if (result && result.body) {
          this.successMessages.push({
            field: 'Consultant Invitation Email Sent',
            detail: 'Consultant Invitation Email Sent Successfully',
            severity: 'success'
          });
          this.userService.getUserProfile(this.username).subscribe((result: any) => {
              if (result && result.body) {
                this.populateData(result.body);
                this.showModalSuccessMessagesToUser();
                this.closeConsultantInvitationModal();
              }
            }, (error: HttpErrorResponse) => {
              if (error.status == 401) {
                this.modalErrorMessages.push({
                  field: 'Get Profile Error',
                  detail: 'You have logged out due to session being invalid. ' + error.error.message,
                  severity: 'error'
                });
                this.showModalErrorMessagesToUser();
                this.routerChild.navigateByUrl('app/login');
              }
            });
          this.showSuccessMessagesToUser();

        }
      }, (error: HttpErrorResponse) => {
        this.inviteButtonClicked = false;
        this.messages.push({
          field: 'Consultant Invitation Email Failed to Send',
          detail: 'Consultant Invitation Email Failed to send',
          severity: 'error'
        });
        this.showMessagesToUser();
      });
  }

  calculateExpirationDate2(): void {
    const subscriptionExpDate = new Date(this.mostRecentSubscription.endDate);
    this.subscriptionExpirationDate = subscriptionExpDate.toLocaleDateString();
    this.cancelAtPeriodEnd = this.mostRecentSubscription.cancelAtPeriodEnd;
    const today: Date = new Date();
    console.log('today: ' + today + ' ' + today.toLocaleDateString());
    if (today <= subscriptionExpDate) {
      this.subscriptionActive = true;
    } else {
      this.subscriptionActive = false;
    }

    this.isConsultant = this.mostRecentSubscription.isConsultant;
    this.hasClients = this.mostRecentSubscription.hasClients;
  }

  viewInvoice(invoiceRow: any): any {
    this.pageErrorMessages = [];
    const invoicePdfLink: string = invoiceRow['invoicePdfLink'];
    window.open(invoicePdfLink, '_blank');
  }

  navToChangeSubscriptionPage(): void {
    this.routerChild.navigateByUrl('app/users/dashboard/subscription/pricing/change')
  }

  navToActivateSubscriptionPage(): void {
    this.routerChild.navigateByUrl('app/users/dashboard/subscription/pricing/pay')
  }

  navToUpdatePaymentMethod(): void {
    this.checkoutSessionConsultantV3();
  }

  checkoutSessionConsultantV3(): void {
    this.messages = [];

    this.userService.checkoutSessionUpdatePaymentMethodV3(this.savedEmail)
      .subscribe((result: any) => {
        if (result && result.body && result.body.url) {
          //Checkout Started
          this.successMessages.push({
            field: 'Checkout Session',
            detail: 'Update Payment Method Checkout Session Started.',
            severity: 'success'
          });
          this.showMessagesToUser();
          // @ts-ignore
          window.open(result.body.url, '_self');
        }
      }, (err1: HttpErrorResponse) => {
        this.messages.push({
            field: 'Save Payment Method Checkout Session API Error',
            detail: 'Failed to create a Save Payment Method checkout session.',
            severity: 'error'
        });

        this.showMessagesToUser(8000);
        //Redirect to Subscription payments and checkout.
        this.routerChild.navigateByUrl('app/users/dashboard/subscription/pricing/pay');
      });
  }

  navToCancelRenewalPage(): void {
    this.pageErrorMessages = [];
    this.userService.cancelSubscriptionRenewal(this.username)
      .subscribe((result: any) => {
        if (result && result.body) {
          this.pageSuccessMessages.push({
            field: 'Subscription Renewal Canceled',
            detail: 'Successfully canceled your upcoming renewal...',
            severity: 'success'
          });
          this.showPageSuccessMessagesToUser();
          this.routerChild.navigateByUrl('app/users/dashboard');
        }
      }, (error: HttpErrorResponse) => {
        this.redirectToLogin(error);
        this.pageErrorMessages.push({
          field: 'Subscription Management API Error',
          detail: 'Failed to to get cancel subscription renewal...',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
      })
  }

  navToSelectDefaultPaymentCardPage(): void {
    this.routerChild.navigateByUrl('app/users/dashboard/payment-cards/set-default')
  }

  showReferralCodeErrorMessagesToUser(delayMs: number = 60000): void {
    this.showReferralCodeErrorMessages = true;
    const counterFn = () => {
      this.showReferralCodeErrorMessages = false;
    }
    setTimeout(counterFn, delayMs);
  }

  showReferralCodeSuccessMessagesToUser(delayMs: number = 60000): void {
    this.showReferralCodeSuccessMessages = true;
    const counterFn = () => {
      this.showReferralCodeSuccessMessages = false;
    }
    setTimeout(counterFn, delayMs);
  }

  verifyConsultantReferralCodeWithActiveAccount(): void {
    this.referralCodeErrorMessages = [];
    this.referralCodeSuccessMessages = [];
    this.showReferralCodeErrorMessages = false;
    this.showReferralCodeSuccessMessages = false;
    const referralCodeEl = document.getElementById('referral-code-text-id');
    // @ts-ignore
    let referralCodeTemp: string = referralCodeEl.value;
    let finalReferralCode: any = null;
    if (!referralCodeTemp) {
      this.referralCodeErrorMessages.push({
        field: 'Consultant Referral Code Error',
        detail: 'Consultant Referral Code Missing',
        severity: 'error'
      });
    } else {
      if (referralCodeTemp.length >= 40) {
        this.referralCodeErrorMessages.push({
          field: 'Consultant Referral Code Error',
          detail: 'Client Email must be no longer than 40 characters.',
          severity: 'error'
        });
      } else {
        finalReferralCode = this.apiService.trimLeadingTrailingSpaces(referralCodeTemp);
      }
    }
    if (this.referralCodeErrorMessages.length > 0) {
      this.showReferralCodeErrorMessagesToUser();
      return;
    }
    this.userService.verifyConsultantReferralCodeWithActiveAccount(this.username, finalReferralCode).subscribe(
      (result: any) => {
        if (result && result.body) {
          this.referralCodeSuccessMessages.push({
            field: 'Consultant Referral Code Success',
            detail: 'Consultant Referral Code was successfully verified.',
            severity: 'success'
          });
          this.showReferralCodeSuccessMessagesToUser()
        }
      }, (error: HttpErrorResponse) => {
        this.referralCodeErrorMessages.push({
          field: 'Consultant Referral Code Error',
          detail: 'Consultant Referral Code failed to verify.',
          severity: 'error'
        });
        this.showReferralCodeErrorMessagesToUser()
      }
    );
  }

  openConsultantInvitationModal(): boolean {
    // @ts-ignore
    this.consultantEmailInvitationReminderModal.style.display = "block";
    return true;
  }

  closeConsultantInvitationModal(): boolean {
    // @ts-ignore
    this.consultantEmailInvitationReminderModal.style.display = "none";
    return true;
  }
}
